'use strict';

const angular = require('angular');
const path = require('path');
const moment = require('angular-moment');
const $ = require('jquery');
const platform = require('platform');

import '@uirouter/angularjs';
import 'angular-local-storage';
import 'angular-messages';
import 'bootstrap';
import './styles/theme.scss';
import './styles/main.css';
import 'ng-device-detector';
import 'ua-device-detector';
import 're-tree';

const ngModule = angular.module('siteVisit', [
    'ui.router'
  , 'LocalStorageModule'
  , 'ngMessages'
  , 'angularMoment'
  , 'ng.deviceDetector'
]);

require ('./directives')(ngModule);
require ('./services')(ngModule);
require ('./states')(ngModule);

ngModule.config(['$urlRouterProvider', function ($urlRouterProvider) {
  // For any unmatched url, redirect to /
  $urlRouterProvider.otherwise("/unknown");
}]);
ngModule.config(['localStorageServiceProvider', function(localStorageServiceProvider) {
  // Local (browser) storage config
  localStorageServiceProvider
    .setPrefix('siteVisit')
    .setStorageType('localStorage')
    .setNotify(true, true)
  }]);
ngModule.filter('unsafe', ['$sce', function($sce) {
  // Enable dynamic HTML
  return $sce.trustAsHtml;
}]);
ngModule.directive('ngModel', ['$filter', function( $filter ) {
  // Fix time format for firefox and others...
  return {
      require: '?ngModel',
      link: function(scope, elem, attr, ngModel) {
          if( !ngModel )
              return;
          if( attr.type !== 'time' )
              return;
                  
          ngModel.$formatters.unshift(function(value) {
              return value.replace(/:00\.000$/, '')
          });
      }
  }   
}]);
ngModule.run(['$rootScope', '$state', '$stateParams', '$anchorScroll', 'localStorageService', function($rootScope, $state, $stateParams, $anchorScroll, localStorageService) {
  console.log("Starting SiteVisit!", platform.description);
  // Enforce scroll to top of windows on each state change
  $rootScope.$on('$stateChangeSuccess', function() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  });
  $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels

  localStorageService.set('appName', __APPNAME__);
  localStorageService.set('appVersion', '3.0.2');
  }]);
ngModule.constant('moment', require('moment-timezone'));
ngModule.config(['$locationProvider', function ($locationProvider) {
  console.log($locationProvider.html5Mode());
  $locationProvider.hashPrefix('');
}]);

export default 'siteVisit';
